<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Registrar Actividad
            <router-link :to="{ name: 'Actividades' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  label="Nombre de la actividad:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Pertenece a:</label>
                <v-select
                  v-model="pertenece_id"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  :options="actividades"
                  placeholder="Selecciona una actividad"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="actividad"
                  horizontal
                  :options="actividades"
                  placeholder="Selecciona una actividad"
                />-->
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Tipo:</label>
                <v-select
                  v-model="tipo_act"
                  class="margin-multi"
                  :options="tipo_actividad"
                  placeholder="Selecciona un tipo"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Tipo de pago:</label>
                <v-select
                  v-model="tipo_pago"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  @input="tipoPago()"
                  :options="tipo"
                  placeholder="Selecciona un tipo de pago"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="tipo_pago"
                  horizontal
                  @update:value="tipoPago()"
                  :options="tipo"
                  placeholder="Selecciona un tipo de pago"
                />-->
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Multiplicador de pago:</label>
                <v-select
                  v-model="multiplicador_pago"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  :disabled="isDiabled"
                  :options="multi"
                  placeholder="Selecciona un multiplicador de pago"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="multiplicador_pago"
                  horizontal
                  :disabled="isDiabled"
                  :options="multi"
                  placeholder="Selecciona un multiplicador de pago"
                />-->
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CInput
                  :value.sync="$v.unidad.$model"
                  :isValid="checkIfValid('unidad')"
                  label="Unidad:"
                  placeholder="Unidad..."
                  invalidFeedback=" El campo debe tener como maximo 5 caracteres"
                />
              </CCol>
            </CRow>

            <CRow v-if="checkSerie()">
              <CCol>
                <label>Habilitar numero de serie:</label>
                <br />
                <CSwitch
                  :checked="numero_serie"
                  @update:checked="numSerie()"
                  class="mx-1 ml-3"
                  color="primary"
                  variant="3d"
                />
              </CCol>
            </CRow>

            <CRow v-if="checkBascula()">
              <CCol>
                <label>Habilitar bascula:</label>
                <br />
                <CSwitch
                  :checked="bascula"
                  @update:checked="mBascula()"
                  class="mx-1 ml-3"
                  color="primary"
                  variant="3d"
                />
              </CCol>
            </CRow>

            <CRow v-if="pertenece_id_value">
              <CCol sm="9">
                <label>Tipo de costo:</label>
                <v-select
                  :options="tiposCosto"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un tipo de costo"
                  v-model="tipo_costo"
                  :class="checkIfValid('tipo_costo')===false?'is-invalid':''"
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                >
                  <template #footer v-if="checkIfValid('tipo_costo')===false">
                    <div class="invalid-feedback">Campo requerido</div>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            
            <ExtraConfigInput
              title=""
              parametro="actividades_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Actividades' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addActividad()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Actividad"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'

export default {
  name: "NuevoActividad",

  components: {
    vSelect,
    ExtraConfigInput,
  },

  data() {
    return {
      actividades: [],
      pertenece_id: null,
      tipo: [
        { value: 1, label: "fijo" },
        { value: 2, label: "variable" }
      ],
      multi: [
        { value: 1, label: "evento" },
        { value: 2, label: "cantidad" }
      ],
      tipo_actividad: [
        { value: 1, label: "cultural" },
        { value: 2, label: "cosecha" }
      ],
      tipo_costo: null,
      tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
      tipo_act: "",
      nombre: "",
      tipo_pago: null,
      multiplicador_pago: null,
      unidad: "",
      isDiabled: false,
      numero_serie: false,
      bascula: false,
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      isSerie: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      valid: {flag: true}
    };
  },

  mixins: [validationMixin],
  validations: {
    nombre: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    unidad: {
      // maxLength: maxLength(5)
    },
    tipo_costo: {
      required: (v,data)=>{
        return data.pertenece_id?.value?(v?.value||false):true
      },
    }
  },

  computed: {
    pertenece_id_value(){
      return this.pertenece_id?.value?true:false
    },
    isValidActividad() {
      return !this.$v.nombre.$invalid;
    },
    isValidUnidad() {
      return !this.$v.unidad.$invalid;
    },
    isValidTipoCosto() {
      return !this.$v?.tipo_costo.$invalid;
    }
  },

  created() {
    this.isLoadingPage = true;
    this.$store
      .dispatch("customHTTP", {
        schema: "actividades",
        filter: {
          where: [
            {
              field: "payload->tipo_pago",
              value: "",
              operator: "="
            },
            {
              field: "payload->multiplicador_pago",
              value: "",
              operator: "="
            },
            {
              field: "payload->unidad",
              value: "",
              operator: "="
            }
          ]
        }
      })
      .then(res => {
        this.actividades = res.data.map(actividad => {
          return { value: actividad.id, label: actividad.payload.nombre };
        }).sort((a,b)=>a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    numSerie() {
      this.numero_serie = !this.numero_serie;
    },
    mBascula() {
      this.bascula = !this.bascula;
    },
    checkSerie() {
      if (this.tipo_pago && this.multiplicador_pago) {
        if (
          this.tipo_pago.label == "variable" &&
          this.multiplicador_pago.label == "evento"
        ) {
          return true;
        }
      }
      this.numero_serie = false
      return false;
    },
    checkBascula() {
      if (this.tipo_pago && this.multiplicador_pago) {
        if (
          this.tipo_pago.label == "variable" &&
          this.multiplicador_pago.label == "evento"
        ) {
          return true;
        }
      }
      this.bascula = false
      return false;
    },
    tipoPago() {
      if (this.tipo_pago) {
        if (this.tipo_pago.label == "fijo") {
          this.multiplicador_pago = { value: 2, label: "cantidad" };
          this.isDiabled = true;
        } else {
          this.isDiabled = false;
        }
      } else {
        this.multiplicador_pago = null;
        this.isDiabled = false;
      }
    },
    addActividad() {
      
      this.validateActividad();

      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
        return
      }
      if (this.isValidActividad && this.isValidUnidad && this.isValidTipoCosto) {
        this.isLoading = true;

        // clean numbers extra fileds

        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });
        const newAct = this.$store.dispatch("customActualizarHTTP", {
              schema: "actividades",
              payload: {
                nombre: this.nombre,
                pertenece_id: this.pertenece_id ? this.pertenece_id.value : 0,
                tipo_costo: this.tipo_costo ? this.tipo_costo.value : '',
                tipo: this.tipo_act ? this.tipo_act.label : "",
                tipo_pago: this.tipo_pago ? this.tipo_pago.label : "",
                multiplicador_pago: this.multiplicador_pago
                  ? this.multiplicador_pago.label
                  : "",
                unidad: this.unidad,
                ...(this.fieldsExtraConfig.length > 0)?{extras: this.fieldsExtra}:{},
                ...this.checkSerie()
                ?{serie: this.numero_serie,
                bascula: this.bascula,
                }:{}
              }
            })

        newAct
          .then(() => {
            // console.log(res.data);
            this.currentAlertCounter = 6;
            this.updateCombos();
            // this.$router.push({ name: "Actividades" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field?.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateActividad() {
      this.$v.$touch();
      // this.$v.unidad.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    updateCombos() {
      this.isLoadingPage = true;
      this.$store
        .dispatch("customHTTP", {
          schema: "actividades",
          filter: {
            where: [
              {
                field: "payload->tipo_pago",
                value: "",
                operator: "="
              },
              {
                field: "payload->multiplicador_pago",
                value: "",
                operator: "="
              },
              {
                field: "payload->unidad",
                value: "",
                operator: "="
              }
            ]
          }
        })
        .then(res => {
          this.actividades = res.data.map(actividad => {
            return { value: actividad.id, label: actividad.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
